import { connect } from "react-redux";

import { goToNext, goToPrevious, setPage, goToDestination } from "~/store/middlewares/page";
import { selectPageMode, selectIsDoublePage } from "~/store/ducks/application/page";
import { setFullScreen } from "~/store/ducks/application/screen";
import { selectAbsolutePage, selectIsPresentationActive, selectShowCutout } from "~/store/ducks/user/uistate";
import { selectRelativePage, selectIsAbleToPrint } from "~/store/ducks";
import { selectIsGreaterThanSmall } from "~/store/ducks/application/browser";
import { selectPagesCount, selectTitle } from "~/store/ducks/domain/config";
import {
  selectTotalPageWidth,
  selectTotalPageHeight,
  selectPadSidebarLeft,
  selectPadSidebarRight
} from "~/store/ducks";
import { selectIsDlsActive, selectDisplayMode, toggleCutoutShow } from "~/store/ducks/user/uistate";
import { selectResizableWidth, setResizableWidth } from "~/store/ducks/domain/ui/content";
import { selectNotesDLSOnly } from "~/store/ducks/domain/ui/notes";

import { selectDisplayedPages } from "~/store/selectors/page";

import { showModal } from "~/store/ducks/domain/ui/modal";

import { selectNoteById } from "~/store/ducks/user/notes";

import { absolutePageToRelative } from "~/utils/page";
import { getNoteId } from "~/utils";

import Annotationeer from "./Annotationeer";

console.log("Annotationeer", Annotationeer);

function mapStateToProps(state) {
  const activePages = selectDisplayedPages(state);
  const bookTitle = selectTitle(state);
  const pagesHaveNotes = activePages
    .map(absolutePageToRelative)
    .map(relativePage => getNoteId(bookTitle, relativePage))
    .map(id => selectNoteById(id)(state))
    .some(note => note && note.text.length > 0);

  return {
    isDlsActive: selectIsDlsActive(state),
    isDoublePage: selectIsDoublePage(state),
    activePages,
    pagesCount: selectPagesCount(state),
    absolutePage: selectAbsolutePage(state),
    isGreaterThanSmall: selectIsGreaterThanSmall(state),
    pageWidth: selectTotalPageWidth(state),
    pageHeight: selectTotalPageHeight(state),
    padLeftSide: selectPadSidebarLeft(state),
    padRightSide: selectPadSidebarRight(state),
    relativePage: selectRelativePage(state),
    displayMode: selectDisplayMode(state),
    pageMode: selectPageMode(state),
    isPresentationMode: selectIsPresentationActive(state),
    resizableWidth: selectResizableWidth(state),
    isAbleToPrint: selectIsAbleToPrint(state),
    bookTitle,
    notesDlsOnly: selectNotesDLSOnly(state),
    pagesHaveNotes,
    showCutout: selectShowCutout(state)
  };
}

const mapDispatchToProps = {
  setPage,
  goToNext,
  goToPrevious,
  setFullScreen,
  goToDestination,
  showModal,
  setResizableWidth
};

export default connect(mapStateToProps, mapDispatchToProps)(Annotationeer);
